import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import Immutable from 'immutable';

import config from '../../../config';
import t from '../../../lib/I18n';
import { BreakPoints } from '../../../constants/AppConstants';
import Search from '../../../records/Search';
import Smartcard from '../../../records/customer/Smartcard';

import ResponsiveRender from '../../ResponsiveRender';
import DateTimeSummaryCompact from './DateTimeSummaryCompact';
import DateTimeSummarySideBySide from './DateTimeSummarySideBySide';
import FormComponent from '../../form/FormComponent';
import SectionErrors from '.././SectionErrors';

class DateTimeSummary extends FormComponent {
    static propTypes = {
        search: PropTypes.instanceOf(Search),
        smartcard: PropTypes.instanceOf(Smartcard),
        onChange: PropTypes.func,
        searchErrors: PropTypes.instanceOf(Immutable.Set),
        disableTodayTomorrow: PropTypes.bool
    };

    static defaultProps = {
        search: new Search(),
        onChange: _.noop,
        searchErrors: new Immutable.Set(),
        disableTodayTomorrow: false
    };

    _shouldFocus (prevProps) {
        const prevErrors = prevProps.searchErrors;
        const searchErrors = this.props.searchErrors;
        return this.getErrors(searchErrors).join('') !== this.getErrors(prevErrors).join('');
    }

    getErrors (searchErrors) {
        let errors = [];

        if (searchErrors.has('validateDepartBeforeArrive')) {
            errors.push('booking.dates.errors.departAfterArrive');
        }

        if (searchErrors.has('validateDatesComplete')) {
            errors.push('booking.dates.errors.invalidDate');
        }

        if (searchErrors.has('validateDatesInFuture')) {
            errors.push('booking.dates.errors.pastDate');
        }

        if (searchErrors.has('validateSmartcardPeriodReturn')) {
            errors.push('booking.dates.errors.smartcardPeriodReturn');
        }

        if (searchErrors.has('validateDatesBeforeMax')) {
            errors.push(t('booking.dates.errors.datesAfterMax', { maxOutboundDays: config.get('maxOutboundDays') }));
        }

        return errors;
    }

    handleChange = (search) => {
        this.props.onChange(search.slideAfterChange());
    }

    render () {
        const { search, smartcard, searchErrors, disableTodayTomorrow } = this.props;
        const props = { search, smartcard, onChange: this.handleChange, disableTodayTomorrow };
        return (
            <section className="booking__section datetime" ref={ this.captureFormRef }>
                <ResponsiveRender maxWidth={ BreakPoints.MOBILE_WIDTH }>
                    <DateTimeSummaryCompact { ...props } />
                </ResponsiveRender>
                <ResponsiveRender minWidth={ BreakPoints.MOBILE_WIDTH + 1 }>
                    <DateTimeSummarySideBySide { ...props } />
                </ResponsiveRender>

                <SectionErrors errors={ this.getErrors(searchErrors) } />
            </section>
        );
    }
}

export default DateTimeSummary;



// WEBPACK FOOTER //
// ./src/components/search/dates/DateTimeSummary.js